/**
 * GPO add-on fallback (Globo Product Options)
 *
 * Optional add-ons (e.g. Zip Installation) are ticked GPO checkboxes. The GPO app
 * normally adds them to the cart itself. This script used to ALSO add every ticked
 * add-on before the product, so customers got two of each.
 *
 * Now it only fills a gap: it notes each ticked add-on's cart quantity before the
 * add, waits for the product (and GPO) adds to land, and adds an add-on only if its
 * quantity didn't go up. One of each, whether or not GPO added it.
 */
(function() {
  const originalFetch = window.fetch;
  const SETTLE_MS = 1500; // time for GPO's own add to land after the product add
  let checkInFlight = false;

  function getTickedAddonIds() {
    const gpoApp = document.querySelector('.gpo-app');
    if (!gpoApp) return [];
    const ids = [];
    gpoApp.querySelectorAll('input[type="checkbox"][gpo-data-variant-id]:checked').forEach(function(input) {
      const id = Number(input.getAttribute('gpo-data-variant-id'));
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  async function getCartQuantities() {
    const resp = await originalFetch.call(window, '/cart.js');
    const cart = await resp.json();
    const qty = {};
    cart.items.forEach(function(item) { qty[item.variant_id] = (qty[item.variant_id] || 0) + item.quantity; });
    return qty;
  }

  function getCartSectionIds() {
    const ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function(el) {
      const id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  async function addMissingAddons(addonIds, before) {
    await new Promise(function(r) { setTimeout(r, SETTLE_MS); });
    const after = await getCartQuantities();
    const missing = addonIds.filter(function(id) { return (after[id] || 0) <= (before[id] || 0); });
    if (!missing.length) return;

    const resp = await originalFetch.call(window, '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: missing.map(function(id) { return { id: id, quantity: 1 }; }),
        sections: getCartSectionIds().join(','),
        sections_url: window.location.pathname
      })
    });
    if (!resp.ok) return;
    const data = await resp.json();
    // Re-render the native cart drawer with the add-on included.
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: {}, sourceId: 'gpo-addon', data: { source: 'gpo-addon', sections: data.sections } }
    }));
    console.log('[GPO] added missing add-on(s):', missing.join(', '));
  }

  window.fetch = async function(url, options) {
    const urlStr = typeof url === 'string' ? url : (url && url.url) || String(url);

    // One check per add-to-cart click; GPO's own add (if any) passes straight through.
    if (urlStr.includes('/cart/add') && !checkInFlight) {
      const addonIds = getTickedAddonIds();
      if (addonIds.length) {
        checkInFlight = true;
        let before = null;
        try { before = await getCartQuantities(); } catch (e) { /* skip the check */ }
        const result = originalFetch.apply(window, arguments);
        if (before) {
          result
            .then(function() { return addMissingAddons(addonIds, before); })
            .catch(function(e) { console.warn('[GPO] add-on check failed:', e); })
            .finally(function() { checkInFlight = false; });
        } else {
          checkInFlight = false;
        }
        return result;
      }
    }

    return originalFetch.apply(window, arguments);
  };
})();
